import Vue from 'vue';
export var bus = new Vue();
export function setup() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$use = _ref.use,
      use = _ref$use === void 0 ? true : _ref$use;
}